// Generated by CoffeeScript 1.11.1
(function() {
  module.exports = {
    PNG: require('./image_exports/png')
  };

}).call(this);
